import { render, staticRenderFns } from "./ImageMiniatureEditor.vue?vue&type=template&id=59a650cb"
import script from "./ImageMiniatureEditor.vue?vue&type=script&lang=js"
export * from "./ImageMiniatureEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports